<template>
<section id="osrOccurrenceSection" class="section bgLight pretty-top pretty-bottom">
  <div class="container">
    <div class="columns is-multiline is-vcentered is-centered">
      <div class="column is-12-tablet has-text-centered">
        <h2 class="has-text-centered">{{ $t("profile.OSRBirdStatus.osrOccurrenceSection.header") }}</h2>
        <div class="bold" v-html="$t('profile.OSRBirdStatus.osrOccurrenceSection.description', {sppName: state.sppName, mapStartYear: state.sppGroup?.occurrenceMapStartYear, mapEndYear: state.sppGroup?.occurrenceMapEndYear})"></div>
        </div>
      <div class="column is-12-tablet">
        <div class="columns is-multiline centered " style="align-items: end;">
          <div class="column is-12-tablet is-7-desktop">
            <simple-map :widthPct="80" :layerNames="layerNames" :isOSR="true"/>
          </div>
          <div class="column is-12-tablet is-5-desktop flex-legend">
            <div class="center mt-1">
              <svg style="height:140px; width: 100px;">
                <use xlink:href="@/assets/sprite.svg#osm-inset-ab-map"></use>
              </svg>

            </div>

          <!-- occurrence dots-->
            <div>
              <div class="center border">
                <div class="legend-header">
                    <span class="legend-header">Species Occurrence</span>
                </div>

                <div class="legend-row subRow">
                    <div class="legend circle size3" style="background-color: rgb(154, 21, 21);"></div>
                    <span>Species Detected </span>
                </div>
                <div class="legend-row subRow">
                    <div class="legend circle size3" style="background-color: rgb(130, 130, 130);"></div>
                    <span>Not Detected</span>
                </div>
                <div class="legend-row subRow">
                    <div class="legend circle size2" style="background-color: rgb(78, 78, 78);"></div>
                    <span>Site not yet sampled</span>
                </div>
            </div>
            </div>
            <!-- 100 - 0 -->
            <div class="center mt-1">
              <span>100</span>
              <svg style="height:20px;">
                <use xlink:href="@/assets/sprite.svg#current-legend"></use>
              </svg>
              <span>0</span>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>

</template>

<script>
import { useApp } from '@/composables/state/profileState';
import AlbertaStandardMap from '@/components/map/AlbertaStandardMap.vue'
import {
  occurrenceMapName, suitablityMapNames
}
  from '@/config/profile-config.js';
export default {
  name: 'osr-occurrence-map-subsection',
  components: {
    'simple-map': AlbertaStandardMap
  },
  setup () {
    const { state } = useApp();

    const layerNames = [occurrenceMapName, suitablityMapNames[0]];
    const legendLayerName = [occurrenceMapName];
    return {
      state,
      layerNames,
      legendLayerName
    }
  }
}
</script>
<style scoped>
.legend {
  width: 15px;
  height: 15px;
  display: inline-block;
  margin-right: 3px;
}
.legend-row.subRow {
  margin-left: 10px;
}
.legend-header {
  font-weight: 550;
  font-size: 1rem;
}

.legend.circle {
  border-radius: 100px;
}
.legend.circle.size2 {
  width: 5px;
  height: 5px;
}
.legend.circle.size3,
.legend.circle.size4 {
  width: 8px;
  height: 8px;
}
.center {
  margin-left:auto;
  margin-right: auto;
}

.border {
  border: 1px solid #333;
  max-width: 200px;
  padding: 10px;
}
.flex-legend {
  display: flex;
  flex-direction: column;
}
</style>
